import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getUnitDetails, clearUnitDetails } from '../../../../redux/Slices/authSlice';

const UnitsDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { unitDetails, isLoading } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getUnitDetails(id));
    return () => dispatch(clearUnitDetails());
  }, [dispatch, id]);

  return (
    <div style={{ padding: '30px', backgroundColor: '#14263b', minHeight: '100vh', color: 'white' }}>
      <div style={{ maxWidth: '700px', margin: '0 auto', backgroundColor: '#1b3350', borderRadius: '12px', padding: '24px', border: '1px solid #333' }}>
        <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1 style={{ margin: 0, fontSize: '22px' }}>تفاصيل وحدة القياس</h1>
          <button
            type="button"
            onClick={() => navigate(-1)}
            style={{
              backgroundColor: 'transparent',
              color: '#fff',
              border: '1px solid #444',
              borderRadius: '6px',
              padding: '8px 16px',
              cursor: 'pointer',
            }}
          >
            رجوع
          </button>
        </div>

        {(!unitDetails && isLoading) ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#ccc' }}>جاري تحميل البيانات...</div>
        ) : !unitDetails ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#ccc' }}>لا توجد بيانات لعرضها</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <DetailRow label="الاسم بالعربية" value={unitDetails.name_ar || '—'} />
            <DetailRow label="الاسم بالإنجليزية" value={unitDetails.name_en || '—'} />
            <DetailRow label="الرمز" value={unitDetails.symbol || '—'} />
            <DetailRow label="الحالة" value={unitDetails.is_active ? 'نشطة' : 'موقوفة'} highlight={unitDetails.is_active ? '#27ae60' : '#c0392b'} />
          </div>
        )}
      </div>
    </div>
  );
};

const DetailRow = ({ label, value, highlight }) => (
  <div style={{ backgroundColor: '#1a1f2e', borderRadius: '8px', padding: '16px', border: '1px solid #333' }}>
    <div style={{ color: '#ccc', marginBottom: '6px', fontSize: '13px' }}>{label}</div>
    <div style={{ fontSize: '16px', fontWeight: 'bold', color: highlight || '#fff' }}>{value}</div>
  </div>
);

export default UnitsDetails;

